/**
 * Gets locale for two letter language code
 *
 * @param {string} langCode - Two letter language code, eg. "sv", "en", "nl"
 * @param {object} languageFallbacks - Map for language code to locale: eg. {sv: 'sv_SE', nl: 'nl_NL', en: 'en_US'}
 *
 * @return {string|null} Four letter language_region code, eg. "sv_SE", "en_US", "nl_NL"
 */
const getLocaleForLanguage = function(langCode, languageFallbacks = {}) {
    if (languageFallbacks && languageFallbacks[langCode]) {
        return languageFallbacks[langCode]
    }

    return null
}

export {getLocaleForLanguage}
